import {CommonModule} from '@angular/common';
import {APP_INITIALIZER, NgModule, inject} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideApollo} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {InMemoryCache} from '@apollo/client/cache';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {GraphQLModule} from '@odp/shared/lib/graph-ql.module';
import {EventService} from '@odp/shared/lib/event-service/event.service';
import {API_URLS, AppConfig, APP_CONF, EVENT_SERVICE} from '@odp/shared/lib/types';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    GraphQLModule.forRoot()
  ],
  providers: [
    {
      provide: API_URLS,
      useFactory: (appConfig: AppConfig) => {
        return appConfig.odp;
      },
      deps: [APP_CONF]
    },
    {provide: EVENT_SERVICE, useClass: EventService},
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const appConfig = inject(APP_CONF);
      return {
        link: httpLink.create({uri: appConfig.odp.graphqlEndpoint}),
        cache: new InMemoryCache()
      };
    })
  ]
})
export class AppModule {
  constructor() {}
}
